function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  if (summary) {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    );
    if (summary.nextElementSibling) {
      if (summary.nextElementSibling.getAttribute("id")) {
        summary.setAttribute("aria-controls", summary.nextElementSibling.id);
      }
    }
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    if (summary.closest("header-drawer, menu-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

async function addToCart(items) {
  try {
    // Normalize items to array format
    const itemsArray = Array.isArray(items) ? items : [items];

    // Split items into chunks of 5 to avoid potential API limits
    const CHUNK_SIZE = 5;
    const chunks = [];
    for (let i = 0; i < itemsArray.length; i += CHUNK_SIZE) {
      chunks.push(itemsArray.slice(i, i + CHUNK_SIZE));
    }

    let cartData;
    // Process chunks sequentially
    for (const chunk of chunks) {
      const response = await fetch("/cart/add.js", {
        ...fetchConfig(),
        body: JSON.stringify({
          items: chunk,
          sections: ["cart-drawer", "cart-icon-bubble"],
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || "Error adding items to cart");
      }

      cartData = await response.json();
    }

    // Get cart drawer and render sections if it exists
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.remove("is-empty");
      cartDrawer.style.display = "block";

      const drawerInner = cartDrawer?.querySelector(".drawer__inner");
      if (drawerInner) {
        drawerInner.classList.remove("is-empty");
      }

      if (cartData?.sections) {
        cartDrawer.renderContents(cartData);
      }
    } else {
      window.location.href = "/cart";
    }

    return cartData;
  } catch (error) {
    console.error("Error adding to cart:", error);
    throw error;
  }
}

/**
 * Adds the specified variant(s) to the cart and opens/updates the cart drawer.
 * @param {number|number[]} variantIds - A single variant ID or an array of variant IDs to add to the cart.
 * @param {number} [quantity=1] - (Optional) Quantity to add for each variant. Defaults to 1.
 * @returns {Promise<void>}
 */
window.addItemsToCart = async function (variantIds, quantity = 1) {
  // Normalize to array
  const ids = Array.isArray(variantIds) ? variantIds : [variantIds];
  // Build Shopify cart item objects
  const items = ids.map((id) => ({ id, quantity }));
  try {
    await addToCart(items);
  } catch (error) {
    // Optionally, show a toast or error UI here
    console.error("window.addToCart error:", error);
  }
};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this._resizeObserver = null;
    this._resizeTimeout = null;

    if (!this.slider || !this.sliderItems.length) return;

    // Throttle resize handling
    this.handleResize = this.throttleResize.bind(this);

    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    if (isMobile) {
      this.dataset.orientation = "horizontal";
      this.sliderItemOffset =
        this.sliderItems[1]?.offsetLeft - this.sliderItems[0]?.offsetLeft || 0;
    }

    this.initButtons();
    this.initResizeObserver();
  }

  throttleResize(entries) {
    if (this._resizeTimeout) {
      window.cancelAnimationFrame(this._resizeTimeout);
    }

    this._resizeTimeout = window.requestAnimationFrame(() => {
      this.handleResizeAction(entries);
    });
  }

  handleResizeAction(entries) {
    if (!entries.length) return;

    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    if (isMobile) {
      this.dataset.orientation = "horizontal";
      this.sliderItemOffset =
        this.sliderItems[1]?.offsetLeft - this.sliderItems[0]?.offsetLeft || 0;
    }
  }

  initResizeObserver() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }

    this._resizeObserver = new ResizeObserver(this.handleResize);
    this._resizeObserver.observe(this.slider);
  }

  disconnectedCallback() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
    if (this._resizeTimeout) {
      window.cancelAnimationFrame(this._resizeTimeout);
      this._resizeTimeout = null;
    }
  }

  initButtons() {
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.prevButton || !this.nextButton) return;

    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    const isVertical =
      !isMobile && this.closest('[data-orientation="vertical"]') !== null;

    if (isVertical) {
      const firstThumb = this.sliderItems[0];
      const secondThumb = this.sliderItems[1];
      if (!firstThumb || !secondThumb) return;

      const totalItemHeight = secondThumb.offsetTop - firstThumb.offsetTop;
      const direction = event.currentTarget.name === "next" ? 1 : -1;

      this.slider.scrollBy({
        top: direction * totalItemHeight,
        behavior: "smooth",
      });
    } else {
      this.sliderItemOffset =
        this.sliderItems[1]?.offsetLeft - this.sliderItems[0]?.offsetLeft || 0;
      const step = parseInt(event.currentTarget.dataset.step || 1);
      const slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;

      this.slider.scrollTo({
        left: slideScrollPosition,
        behavior: "smooth",
      });
    }
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this._isUpdating = false;
    this._isRendering = false;

    // Initialize with URL variant if present
    this.initializeWithUrlVariant();
  }

  initializeWithUrlVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");

    if (!variantId) {
      // No variant in URL, reset all selects to "Choose Option"
      this.querySelectorAll("select").forEach((select) => {
        select.value = "";
      });
      // Add class to indicate no variant is selected
      this.toggleVariantSelectionClass(false);
      return;
    } else {
      document.querySelector(".availability-tables").classList.remove("hidden");
    }

    // Find the variant that matches the URL
    const variants = JSON.parse(
      this.querySelector('script[type="application/json"]').textContent
    );
    const currentVariant = variants.find(
      (variant) => variant.id.toString() === variantId
    );

    if (!currentVariant) return;

    // Update all selects to match the variant
    this._isUpdating = true;
    const selects = this.querySelectorAll("select");

    selects.forEach((select, index) => {
      const optionIndex = index + 1;
      const optionValue = currentVariant[`option${optionIndex}`];

      // Find and select the matching option
      const option = Array.from(select.options).find(
        (opt) => opt.value === optionValue
      );
      if (option) {
        select.value = optionValue;
      }
    });

    // Trigger variant change to update the UI
    this.currentVariant = currentVariant;
    this.updateSelectedSwatchValue({ target: selects[0] });
    // Remove class since variant is selected
    this.toggleVariantSelectionClass(true);
    this._isUpdating = false;
  }

  onVariantChange(event) {
    if (this._isUpdating || this._isRendering) {
      return;
    }

    this.updateOptions();

    // Always update variant statuses to recalculate availability
    this.updateVariantStatuses();

    // If any option is null (not selected), disable add to cart and show message
    if (this.options.some((option) => option === null)) {
      this.toggleAddButton(
        true,
        window.variantStrings.selectOption || "Please select all options",
        true
      );
      // Add class to indicate no variant is selected
      this.toggleVariantSelectionClass(false);
      return;
    }

    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    // Remove class since variant is selected
    this.toggleVariantSelectionClass(true);

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      // Add class since no valid variant is found
      this.toggleVariantSelectionClass(false);
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();

      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: this.dataset.section,
          variant: this.currentVariant,
          variantId: this.currentVariant.id,
        },
      });
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value || null;
        }
        if (element.tagName === "FIELDSET") {
          return (
            Array.from(element.querySelectorAll("input")).find(
              (radio) => radio.checked
            )?.value || null
          );
        }
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
    document.dispatchEvent(
      new CustomEvent("variant-url-updated", {
        bubbles: true,
        cancelable: true,
        detail: { timestamp: Date.now() },
      })
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    const selectedValues = [];

    // Collect all currently selected values from dropdowns
    inputWrappers.forEach((optionWrapper, index) => {
      const select = optionWrapper.querySelector("select");
      if (select) {
        selectedValues[index] = select.value || null;
      } else {
        const radio = optionWrapper.querySelector(":checked");
        selectedValues[index] = radio ? radio.value : null;
      }
    });

    // Ensure we have variant data
    const variantData = this.getVariantData
      ? this.getVariantData()
      : this.variantData || [];

    // Get all variants that match the currently selected option1
    const selectedOptionOne = selectedValues[0];
    const selectedOptionOneVariants = selectedOptionOne
      ? variantData.filter((variant) => variant.option1 === selectedOptionOne)
      : [];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];

      // Build availability based on all previous selections
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => {
          if (!variant.available) return false;

          // Check if variant matches all previous selections
          for (let i = 1; i < index; i++) {
            const previousSelected = selectedValues[i];
            if (
              previousSelected &&
              variant[`option${i + 1}`] !== previousSelected
            ) {
              return false;
            }
          }
          return true;
        })
        .map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });

    // After updating variant statuses, dispatch the custom event
    document.dispatchEvent(new CustomEvent("variant-url-updated"));
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        // Skip placeholder option (value="") so its label stays as "Choose Option"
        if (!value) return;
        // Update option label text to reflect availability
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value
            );

        // Critically, toggle the disabled state so previously unavailable options
        // become selectable when availability changes based on prior selections
        element.disabled = !availableElement;
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(
      `[id^="MediaGallery-${this.dataset.section}"] ul`
    );
    const mediaGalleryDestination = html.querySelector(
      `[id^="MediaGallery-${this.dataset.section}"] ul`
    );

    const thumbnailsSource = document.querySelector(
      `[id^="GalleryThumbnails-${this.dataset.section}"]`
    );
    const thumbnailsDestination = html.querySelector(
      `[id^="GalleryThumbnails-${this.dataset.section}"]`
    );

    // Helper function to refresh source data
    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(
        mediaGallerySource.querySelectorAll("li[data-media-id]")
      );
      const sourceSet = new Set(
        mediaGallerySourceItems.map((item) => item.dataset.mediaId)
      );
      const sourceMap = new Map(
        mediaGallerySourceItems.map((item, index) => [
          item.dataset.mediaId,
          { item, index },
        ])
      );
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    // Update main gallery
    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(
        mediaGalleryDestination.querySelectorAll("li[data-media-id]")
      );
      const destinationSet = new Set(
        mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
      );
      let shouldRefresh = false;

      // Remove is-active class from all items first
      mediaGallerySourceItems.forEach((item) => {
        item.classList.remove("is-active");
      });

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh)
        [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach(
        (destinationItem, destinationIndex) => {
          const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

          if (sourceData && sourceData.index !== destinationIndex) {
            mediaGallerySource.insertBefore(
              sourceData.item,
              mediaGallerySource.querySelector(
                `li:nth-of-type(${destinationIndex + 1})`
              )
            );
          }
        }
      );

      // Add is-active class to first item
      const firstItem = mediaGallerySource.querySelector("li[data-media-id]");
      if (firstItem) {
        firstItem.classList.add("is-active");
      }
    }

    // Update thumbnails
    if (thumbnailsSource && thumbnailsDestination) {
      // Get the slider instance if it exists
      const thumbnailSlider = thumbnailsSource.querySelector(".thumbnail-list");
      const wasSliderInitialized =
        thumbnailSlider && "isSlideVisible" in thumbnailSlider;

      // Store the current scroll position if slider exists
      const currentScroll = thumbnailSlider ? thumbnailSlider.scrollLeft : 0;

      // Update the content
      thumbnailsSource.innerHTML = thumbnailsDestination.innerHTML;

      // If there was a slider, restore the scroll position
      if (wasSliderInitialized) {
        const newSlider = thumbnailsSource.querySelector(".thumbnail-list");
        if (newSlider) {
          newSlider.scrollLeft = currentScroll;
        }
      }

      // Update first thumbnail to be active
      const firstThumbnail = thumbnailsSource.querySelector(".thumbnail");
      if (firstThumbnail) {
        firstThumbnail.setAttribute("aria-current", "true");
      }
    }

    // Update active media if needed
    if (this.currentVariant && this.currentVariant.featured_media) {
      const gallery = document.querySelector(
        `[id^="MediaGallery-${this.dataset.section}"]`
      );
      if (gallery?.setActiveMedia) {
        gallery.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        );
      }
    }
  }

  async renderProductInfo() {
    try {
      if (this._isRendering) return;
      this._isRendering = true;

      const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
      const response = await fetch(url);
      const html = await response.text();

      const div = document.createElement("div");
      div.innerHTML = html;

      const newSection = div.querySelector(`[id^="MainProduct-"]`);

      if (!newSection) {
        console.error("New section content not found in response");
        this._isRendering = false;
        return;
      }

      const currentSection = document.querySelector(`[id^="MainProduct-"]`);

      if (!currentSection) {
        console.error("Current section not found in page");
        this._isRendering = false;
        return;
      }

      // Remove animation classes from the new section
      const animatedElements = newSection.querySelectorAll(
        ".animate--slide-in, .scroll-trigger"
      );
      animatedElements.forEach((element) => {
        element.classList.remove("animate--slide-in", "scroll-trigger");
      });

      // Remove hidden class from availability-tables in the response
      const availabilityTables = newSection.querySelector(
        ".availability-tables"
      );
      if (availabilityTables) {
        availabilityTables.classList.remove("hidden");
      }

      const scrollPosition = window.scrollY;

      this.cleanupSection(currentSection);

      await new Promise((resolve) => requestAnimationFrame(resolve));

      currentSection.replaceWith(newSection);

      window.scrollTo({
        top: scrollPosition,
        behavior: "instant",
      });

      // Let the new media gallery sort itself based on URL
      const mediaGallery = newSection.querySelector("media-gallery");
      if (mediaGallery) {
        // Wait for custom element to be initialized
        await customElements.whenDefined("media-gallery");
        mediaGallery.sortMediaByUrl();
      }

      if (window.reinitializeComponents) {
        window.reinitializeComponents(newSection);
      }

      const variantSelects = newSection.querySelector("variant-selects");
      if (variantSelects) {
        variantSelects._isUpdating = true;

        variantSelects.currentVariant = this.currentVariant;

        const inputs = variantSelects.querySelectorAll(
          'select, input[type="radio"]'
        );
        inputs.forEach((input) => {
          if (input.value === this.currentVariant[input.name]) {
            if (input.tagName === "SELECT") {
              input.selectedIndex = Array.from(input.options).findIndex(
                (option) => option.value === input.value
              );
            } else {
              input.checked = true;
            }
          }
        });

        setTimeout(() => {
          variantSelects._isUpdating = false;
        }, 100);
      }
    } catch (error) {
      console.error("Error rendering product info:", error);
    } finally {
      this._isRendering = false;
    }
  }

  cleanupSection(section) {
    // Find all custom elements that might have observers
    const customElements = section.querySelectorAll("*");
    customElements.forEach((element) => {
      // Cleanup any ResizeObservers
      if (element._resizeObserver) {
        element._resizeObserver.disconnect();
        element._resizeObserver = null;
      }

      // Cleanup any IntersectionObservers
      if (element._intersectionObserver) {
        element._intersectionObserver.disconnect();
        element._intersectionObserver = null;
      }

      // Cleanup any MutationObservers
      if (element._mutationObserver) {
        element._mutationObserver.disconnect();
        element._mutationObserver = null;
      }

      // Instead of cloning, just remove known event listeners
      if (element instanceof HTMLElement) {
        const commonEvents = [
          "click",
          "change",
          "input",
          "keydown",
          "keyup",
          "focus",
          "blur",
        ];
        commonEvents.forEach((eventType) => {
          element.removeEventListener(eventType, element.onclick);
          element.removeEventListener(eventType, element.onchange);
          element.removeEventListener(eventType, element.oninput);
        });
      }
    });

    // Specific cleanup for known components
    const mediaGallery = section.querySelector("media-gallery");
    if (mediaGallery) {
      if (mediaGallery._resizeObserver) {
        mediaGallery._resizeObserver.disconnect();
        mediaGallery._resizeObserver = null;
      }
      // Remove variant change listener if it exists
      document.removeEventListener(
        "variant-url-updated",
        mediaGallery.handleVariantChange
      );
    }

    const sliders = section.querySelectorAll("slider-component");
    sliders.forEach((slider) => {
      if (slider._resizeObserver) {
        slider._resizeObserver.disconnect();
        slider._resizeObserver = null;
      }
    });
  }

  initializeComponents(container) {
    // Re-attach any necessary event listeners or initialize components
    const variantSelects = container.querySelector("variant-selects");
    if (variantSelects) {
      variantSelects.addEventListener(
        "change",
        this.onVariantChange.bind(this)
      );
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  /**
   * Toggles a CSS class on the add to cart button to indicate variant selection state
   * @param {boolean} hasVariantSelected - Whether a variant is currently selected
   */
  toggleVariantSelectionClass(hasVariantSelected) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    if (hasVariantSelected) {
      addButton.classList.remove("variant-not-selected");
    } else {
      addButton.classList.add("variant-not-selected");
    }
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this)
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

if (!customElements.get("show-more-button")) {
  customElements.define(
    "show-more-button",
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector("button");
        button.addEventListener("click", (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target
            .closest(".parent-display")
            .querySelector(".show-more-item");
          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains("hidden") &&
            nextElementToFocus.querySelector("input")
          ) {
            nextElementToFocus.querySelector("input").focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target
          .closest('[id^="Show-More-"]')
          .closest(".parent-display");
        const parentWrap = parentDisplay.querySelector(".parent-wrap");
        this.querySelectorAll(".label-text").forEach((element) =>
          element.classList.toggle("hidden")
        );
        parentDisplay
          .querySelectorAll(".show-more-item")
          .forEach((item) => item.classList.toggle("hidden"));
        if (!this.querySelector(".label-show-less")) {
          this.classList.add("hidden");
        }
      }
    }
  );
}

class ToastNotification extends HTMLElement {
  constructor() {
    super();
  }

  show(message, type = "success") {
    this.innerHTML = `
      <div class="toast-notification ${type}">
        <span class="toast-icon">${type === "success" ? "✓" : "✕"}</span>
        <span class="toast-message">${message}</span>
        <button class="toast-close">✕</button>
      </div>
    `;

    const toast = this.querySelector(".toast-notification");
    const closeBtn = this.querySelector(".toast-close");

    closeBtn.addEventListener("click", () => this.remove());

    // Auto remove after 5 seconds
    setTimeout(() => this.remove(), 5000);
  }
}

customElements.define("toast-notification", ToastNotification);

// Update NotifyMeButton to use the new toast component
class NotifyMeButton extends HTMLElement {
  constructor() {
    super();
    this.modalTemplate = `
      <div class="notify-me-overlay">
        <div class="notify-me-popup">
          <button class="notify-me-close">&times;</button>
          <h2 class="notify-me-popup__heading">Get notified when back in stock</h2>
          <p class="notify-me-popup__subheading">We will inform you when the product arrives in stock. Please leave your valid email address below.</p>
          <form>
            <p class="product-info"></p>
            <div class="field">
              <input type="text" name="name" placeholder="Name" required pattern="^[a-zA-Z]+$" title="Please enter letters only, no spaces, numbers or special characters">
            </div>
            <div class="field">
              <input type="email" name="email" placeholder="Email" required>
            </div>
            <div class="field">
              <input type="checkbox" id="terms" name="terms" required>
              <label for="terms">I have read and agree to the 
                <a href="/policies/terms-of-service" target="_blank">Terms & Conditions</a> and 
                <a href="/policies/privacy-policy" target="_blank">Privacy Policy</a>.
              </label>
            </div>
            <button type="submit" class="button button--primary">NOTIFY ME</button>
          </form>
        </div>
      </div>
    `;

    this.modal = null;
  }

  connectedCallback() {
    // Only set up the button if one doesn't already exist
    if (!this.querySelector(".notify-me-trigger")) {
      this.setupButton();
    }
  }

  setupButton() {
    const button = document.createElement("button");
    button.classList.add("notify-me-trigger");
    button.textContent = "Notify Me";

    button.addEventListener("click", (e) => {
      e.preventDefault();
      this.showModal();
    });

    this.appendChild(button);
  }

  showModal() {
    // Create new modal every time
    const template = document.createElement("div");
    template.innerHTML = this.modalTemplate;
    this.modal = template.firstElementChild;

    // Set product info
    const productInfo = this.modal.querySelector(".product-info");
    productInfo.textContent = this.getAttribute("product-title");

    // Pre-fill customer info if available
    const nameInput = this.modal.querySelector('input[name="name"]');
    const emailInput = this.modal.querySelector('input[name="email"]');
    nameInput.value = this.getAttribute("customer-name") || "";
    emailInput.value = this.getAttribute("customer-email") || "";

    // Setup close button
    const closeButton = this.modal.querySelector(".notify-me-close");
    closeButton.addEventListener("click", () => this.hideModal());

    // Setup form submission
    const form = this.modal.querySelector("form");
    form.addEventListener("submit", (e) => this.handleSubmit(e));

    // Add click outside to close
    this.modal.addEventListener("click", (e) => {
      if (e.target === this.modal) {
        this.hideModal();
      }
    });

    // Append to body and show
    document.body.appendChild(this.modal);
    this.modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }

  hideModal() {
    if (this.modal && document.body.contains(this.modal)) {
      document.body.removeChild(this.modal);
      document.body.style.overflow = "";
      this.modal = null; // Reset modal reference
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const email = form.email.value;
    const name = form.name.value;
    const sku = this.getAttribute("product-sku");

    // Close modal immediately
    this.hideModal();

    try {
      const response = await fetch(
        "https://keeler-notify-me.pdsync.com.au/shopify/api/users",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            name,
            sku,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "An error occurred while processing your request"
        );
      }

      const toast = document.createElement("toast-notification");
      document.body.appendChild(toast);
      toast.show(
        "Thanks! We'll notify you when this product becomes available.",
        "success"
      );
    } catch (error) {
      const toast = document.createElement("toast-notification");
      document.body.appendChild(toast);
      toast.show(error.message || "An unexpected error occurred", "error");
    }
  }

  disconnectedCallback() {
    // Clean up modal when component is removed
    if (this.modal && document.body.contains(this.modal)) {
      document.body.removeChild(this.modal);
    }
  }
}

customElements.define("notify-me-button", NotifyMeButton);

class TooltipModal extends HTMLElement {
  constructor() {
    super();
    this.modalId = `modal-${Math.floor(Math.random() * 1000000)}`;
    this.triggerButton = this.querySelector(".tooltip-trigger");
    this.tooltipContent = this.querySelector(".tooltip-content");
    this.originalContent = null;
    this.modal = null;
    this.overlay = null;

    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  connectedCallback() {
    if (!this.triggerButton || !this.tooltipContent) return;

    // Store original content
    this.originalContent = this.tooltipContent.innerHTML;

    // Remove hover functionality
    this.tooltipContent.style.display = "none";

    // Add click event to trigger
    this.triggerButton.addEventListener("click", this.openModal);
  }

  openModal(event) {
    event.preventDefault();

    // Create overlay
    this.overlay = document.createElement("div");
    this.overlay.className = "tooltip-modal-overlay";
    this.overlay.addEventListener("click", this.closeModal);

    // Create modal
    this.modal = document.createElement("div");
    this.modal.className = "tooltip-modal";
    this.modal.id = this.modalId;

    // Create close button
    const closeButton = document.createElement("button");
    closeButton.className = "tooltip-modal-close";
    closeButton.setAttribute("aria-label", "Close");
    closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/></svg>`;
    closeButton.addEventListener("click", this.closeModal);

    // Create content container
    const contentContainer = document.createElement("div");
    contentContainer.className = "tooltip-modal-content";
    contentContainer.innerHTML = this.originalContent;

    // Assemble modal
    this.modal.appendChild(closeButton);
    this.modal.appendChild(contentContainer);

    // Add to document
    document.body.appendChild(this.overlay);
    document.body.appendChild(this.modal);

    // Add escape key listener
    document.addEventListener("keydown", this.handleEscapeKey);

    // Prevent body scrolling
    document.body.classList.add("tooltip-modal-open");

    // Trigger animation with a slight delay
    setTimeout(() => {
      this.overlay.classList.add("active");
      this.modal.classList.add("active");
    }, 10);
  }

  closeModal() {
    if (!this.modal || !this.overlay) return;

    // Start fade out animation
    this.overlay.classList.remove("active");
    this.modal.classList.remove("active");

    // Remove elements after animation completes
    setTimeout(() => {
      document.body.removeChild(this.overlay);
      document.body.removeChild(this.modal);
      this.modal = null;
      this.overlay = null;
      document.body.classList.remove("tooltip-modal-open");
    }, 300); // Match transition duration in CSS

    // Remove escape key listener
    document.removeEventListener("keydown", this.handleEscapeKey);
  }

  handleEscapeKey(event) {
    if (event.key === "Escape") {
      this.closeModal();
    }
  }

  disconnectedCallback() {
    if (this.triggerButton) {
      this.triggerButton.removeEventListener("click", this.openModal);
    }
    this.closeModal();
    document.removeEventListener("keydown", this.handleEscapeKey);
  }
}

customElements.define("tooltip-modal", TooltipModal);

function toggleSearchOpenClass() {
  // Get the search input element
  const searchInput = document.getElementById("pd-main-searchbox-input");

  // Check if the element exists
  if (!searchInput) return;

  // Add input event listener
  searchInput.addEventListener("input", function () {
    // If input has text, add class; otherwise, remove it
    if (this.value.trim()) {
      document.body.classList.add("pd-search-open");
    } else {
      document.body.classList.remove("pd-search-open");
    }
  });

  // Also handle the close button click
  const closeButton = document.querySelector(".close_pd_search");
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      searchInput.value = "";
      document.body.classList.remove("pd-search-open");
    });
  }
}

// Initialize the function
document.addEventListener("DOMContentLoaded", toggleSearchOpenClass);

// Fix for iOS Safari image loading issue when returning from product page
// This addresses the known bug where lazy loaded images disappear after navigation
function fixIOSImageLoading() {
  // Check if we're on iOS Safari
  const isIOSSafari =
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    /Safari/.test(navigator.userAgent) &&
    !/CriOS|FxiOS|OPiOS|mercury/.test(navigator.userAgent);

  if (isIOSSafari) {
    // Handle pageshow event (fires when returning from product page)
    window.addEventListener("pageshow", function (event) {
      // Only run if this is a back/forward navigation (not initial load)
      if (event.persisted) {
        // Find all lazy loaded images that might be broken
        const lazyImages = document.querySelectorAll('img[loading="lazy"]');

        lazyImages.forEach((img) => {
          // Check if image is broken or not loaded
          if (!img.complete || img.naturalWidth === 0) {
            // Force reload the image by updating the src
            const originalSrc = img.src;
            img.src = "";
            img.src = originalSrc;
          }
        });

        // Also check for images in product cards specifically
        const productCardImages = document.querySelectorAll(".card__media img");
        productCardImages.forEach((img) => {
          if (!img.complete || img.naturalWidth === 0) {
            const originalSrc = img.src;
            img.src = "";
            img.src = originalSrc;
          }
        });
      }
    });

    // Additional fix for when images are in viewport but still broken
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (
            img.tagName === "IMG" &&
            (!img.complete || img.naturalWidth === 0)
          ) {
            const originalSrc = img.src;
            img.src = "";
            img.src = originalSrc;
          }
        }
      });
    });

    // Observe all lazy loaded images
    document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      observer.observe(img);
    });
  }
}

// Initialize the iOS image fix
document.addEventListener("DOMContentLoaded", fixIOSImageLoading);
